import segment from 'src/js/modules/analytics/segment';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';

const trackBlockLayoutOptionClicked = ({ blockId, blockVariationId }) => {
  if (!blockId) return;

  const {
    trackers: { trackEvent },
    constants,
  } = segment;

  trackEvent(constants.events.BLOCK_LAYOUT_OPTION_CLICKED, {
    dialogId: dialogTypes.BLOCK_SETTINGS,
    blockId,
    blockVariationId,
  });
};

export default trackBlockLayoutOptionClicked;
